import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatMoney } from '../utils'

export const mwmArpuDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'mwmArpud0Avg',
      field: 'mwm_arpu_d0',
      headerName: 'D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmArpud1Avg',
      field: 'mwm_arpu_d1',
      headerName: 'D1',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmArpud3Avg',
      field: 'mwm_arpu_d3',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmArpud7Avg',
      field: 'mwm_arpu_d7',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmArpud10Avg',
      field: 'mwm_arpu_d10',
      headerName: 'D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmArpud30Avg',
      field: 'mwm_arpu_d30',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmArpud180Avg',
      field: 'mwm_arpu_d180',
      headerName: 'D180',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmArpud360Avg',
      field: 'mwm_arpu_d360',
      headerName: 'D360',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmArpuAvg',
      field: 'mwm_arpu',
      headerName: 'Total',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'greyFill',
  headerName: 'MWM ARPU',
}
